import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './home/Home';
import About from './about/About';
import Portfolio from './portfolio/Portfolio';
import Contact from './contact/Contact';
import NotFount from './NotFount';

const MyRouter = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/home" />} />
    <Route path="home" element={<Home />} />
    <Route path="about" element={<About />} />
    <Route path="portfolio" element={<Portfolio />}>
      <Route path="admin" element={<Portfolio />} />
    </Route>
    <Route path="contact" element={<Contact />} />
    <Route path="*" element={<NotFount />} />
  </Routes>
);

export default MyRouter;
